import React from 'react';
import { List } from 'immutable';

import {
  VideoPopup,
  WysiwygField,
  Container,
} from '../../../components';

import './style.scss';

const VideoSeries = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <div id={paragraphKey} className="Paragraph VideoSeries">
      <Container>
        { (title || body) && (
          <div className="VideoSeries__header row">
            { title && (
              <h2 className="VideoSeries__header__title col-12 col-lg-8 col-xl-7">{ title }</h2>
            )}
            { body && (
              <WysiwygField
                property="schema:text"
                className="VideoSeries__header__body col-12 col-lg-8 col-xl-7"
                html={body}
              />
            )}
          </div>
        )}
        { entity.get('field_videos') ? (
          <div className="VideoSeries__videos row">
            { entity.get('field_videos', List()).map((referencedEntity) => {
              const videoId = referencedEntity.get('target_id');
              const language = referencedEntity.getIn(['entity', 'langcode', 0, 'value']);
              const thumbnail = referencedEntity.getIn(['styles', 'teaser_image']);
              const title = referencedEntity.get('title');
              const embedUrl = referencedEntity.get('embed');

              return (
                <VideoPopup
                  key={`media:${videoId}:${language}`}
                  className="col-md-6 col-lg-4"
                  thumbnail={thumbnail}
                  title={title}
                  embedUrl={embedUrl}
                  showIcon={false}
                />
              );
            })}
          </div>
        ) : null}
      </Container>
    </div>
  );
};

export default VideoSeries;
